import {NgModule}                                                                                from '@angular/core';
import {CommonModule}                                                                            from '@angular/common';
import {ReactiveFormsModule}                                                                     from '@angular/forms';
import {MatButtonModule, MatDialogModule, MatFormFieldModule, MatInputModule, MatSnackBarModule} from '@angular/material';
import {ConfirmDialogComponent}                                                                  from './components/dialog/confirm/confirm.component';
import {TokenResolver}                                                                           from './service/token.resolver';

@NgModule({
  declarations: [ConfirmDialogComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSnackBarModule,
    MatDialogModule
  ],
  exports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSnackBarModule,
    MatDialogModule
  ],
  providers: [
    TokenResolver
  ],
  entryComponents: [
    ConfirmDialogComponent
  ]
  })
  export class SharedModule { }
